export default "assets/images/orias-c81175f9.jpg";